module.exports = __webpack_public_path__ + "img/bulma.553c0e25.svg";